import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import Discounts from './discounts'
import KegmeisterFees from './KegmeisterFees'
import KegSizes from './KegSizes'
import SaveButton from './SaveButton'
import Fees from './Fees'
import Tips from './Tips'
import SalesTax from './SalesTax'
import InviteUser from './InviteUser'
import Roles from './Roles'
import DeleteUser from './DeleteUser'
import DateLimit from './DateLimit'
import BankAccount from './BankAccount'
import Locations from './Locations'
import CreateLocation from './CreateLocation'
import FontAwesome from 'react-fontawesome'
import config from '../config'
import { selectors as company_selectors } from '../sagas/account/update';
import { selectors as account_selectors } from '../sagas/account';
import { actions } from '../sagas/account/update';
import Select from 'react-select';
import { reduxForm } from 'redux-form'
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StripeProvider } from 'react-stripe-elements';
import FontAwesomeIcon from 'react-fontawesome'
import Square from '@fortawesome/fontawesome-free-solid/faSquare'
import { NewButton } from '../shared/NewButton'
import { TextInput } from '../shared/TextInput'
import '../stylesheets/Settings.sass'
import '../stylesheets/selector.sass'
import _ from 'lodash'


class AccountSettingsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      discount: false,
      bankAccountInfo: false
    };
  }

  componentWillMount () {
    this.props.getAccountCompany()
  }

  toggleBankAccountInfo = () => {
    this.setState({ bankAccountInfo: !this.state.bankAccountInfo })
  }


  toggleDiscount = () => {
    this.setState({ discount: !this.state.discount })
  }

  handleCustomSubmit = () => {
    this.props.updateAccount(this.props.create)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      this.props.loaded ?
      <div className={'settings-form'}>
        <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
          <div className={'row'}>
            <div className={'column'}>
              { !this.props.create && <BankAccount
                toggleBankAccountInfo={ this.toggleBankAccountInfo }
                bankAccountInfo={ this.state.bankAccountInfo }
                create={ this.props.create }
              />
             }
              <SalesTax
                toggle={ this.props.toggle }
                collectSalesTax={ this.props.collectSalesTax }
                salesTaxChange={ this.props.salesTaxChange }
              />
              <Fees
                fees={ this.props.fees }
              />
              <KegSizes
                selectedKegSizes={ this.props.selectedKegSizes }
                handleKegSizes={ this.props.handleKegSizes }
                allKegSizes = { this.props.allKegSizes }
              />
              <Locations
                locations={ this.props.locations }
                deleteLocation = { this.props.deleteLocation }
              />
              <CreateLocation
                createLocation={ this.props.createLocation }
              />
            </div>
            <div className={'column'}>
              <TextInput
                placeholderText={'Location and Hours Information'}
                inputName={'companyHours'}
                label={'Location and Hours Information'}
                textarea
                rows={3}
                extraClass={'description-text-area'}
              />
              <KegmeisterFees
                passOn={ this.props.passOn }
                handleFeeChange={ this.props.handleFeeChange }
              />
              <Discounts
                toggleDiscount={ this.toggleDiscount }
                discount={ this.state.discount }
                discounts={ this.props.discounts }
              />
              <Tips
                toggle={ this.props.toggle }
                collectTips={ this.props.collectTips }
              />
              <DateLimit
                account={ this.props.initialValues }
              />
            </div>
            <div className={'column'}>
              <Roles
                users={ this.props.users }
                setUserRole={ this.props.setUserRole }
              />
              <InviteUser />
              <DeleteUser
                users={ this.props.users }
                deleteUser={ this.props.deleteUser }
                delete_id={ this.props.delete_id }
                setUserIdToDelete={ this.props.setUserIdToDelete }
              />
            </div>
          </div>
          <div className={'row'}>
            <div className={'column'}>
              &nbsp;
            </div>
            <div className={'column'}>
              <SaveButton
                create={ this.props.create }
              />
            </div>
            <div className={'column'}>
              &nbsp;
            </div>
          </div>
        </form>
        <ReactTooltip />
      </div>
      : null
    )
  }
}

const mapStateToProps = (store) => ({
  initialValues: company_selectors.initialValues(store),
  loaded: company_selectors.loaded(store),
  account_loaded: account_selectors.loaded(store),
  collectSalesTax: company_selectors.collectSalesTax(store),
  collectTips: company_selectors.collectTips(store),
  passOn: company_selectors.passOn(store),
  fees: company_selectors.fees(store),
  allKegSizes: company_selectors.allKegSizes(store),
  selectedKegSizes: company_selectors.selectedKegSizes(store),
  discounts: company_selectors.discounts(store),
  users: company_selectors.users(store),
  delete_id: company_selectors.delete_id(store),
  locations: company_selectors.locations(store),
  company_hours: company_selectors.company_hours(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  {
    overwriteValues: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    form: 'account_settings_form'
  })(AccountSettingsForm)));



// WEBPACK FOOTER //
// ./src/Settings/form.jsx